import "./IconButton.css"
import React, {ReactNode} from "react";

function IconButton({icon, onPress} : {icon: ReactNode,  onPress?: () => void}) {
    const onClick = () => {
        if (onPress) {
        onPress()
        }
    }
  return <div
      onClick={onClick}
  >
    {icon}
  </div>
}
export default IconButton;
